import { useEffect, useRef } from 'react';
import { CHAT_INCIDENT_ID } from '@elementary/common-ui/constants/urlParams';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import useAiChatPanel from '@elementary/common-ui/hooks/useAiChatPanel';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';

const ROOT_CAUSE_START_MESSAGE = 'Find the root cause';

const useOpenIncidentChatFromUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: account, isInitialLoading: isAccountLoading } = useAccount();
  const { openPanel } = useAiChatPanel();

  const chatIncidentId = searchParams.get(CHAT_INCIDENT_ID);
  const handledRef = useRef(false);

  useEffect(() => {
    if (!chatIncidentId) {
      handledRef.current = false;
      return;
    }
    if (isAccountLoading) return;
    if (handledRef.current) return;
    if (!account?.ai_features_enabled) return;
    handledRef.current = true;

    openPanel({
      startMessage: ROOT_CAUSE_START_MESSAGE,
      context: { incidentIds: [chatIncidentId] },
    });

    setSearchParams(
      (prev) => {
        prev.delete(CHAT_INCIDENT_ID);
        return prev;
      },
      { replace: true },
    );
  }, [
    chatIncidentId,
    account?.ai_features_enabled,
    isAccountLoading,
    openPanel,
    setSearchParams,
  ]);
};

export default useOpenIncidentChatFromUrl;
